import createIcon from '../../createIcon';

/**
 * @component @name Science
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTkuODAwMiAxOC40TDE0LjAwMDIgMTAuNjdWNi41TDE1LjM1MDIgNC44MUMxNS42MTAyIDQuNDggMTUuMzgwMiA0IDE0Ljk2MDIgNEg5LjA0MDE4QzguNjIwMTggNCA4LjM5MDE3IDQuNDggOC42NTAxOCA0LjgxTDEwLjAwMDIgNi41VjEwLjY3TDQuMjAwMTggMTguNEMzLjcxMDE4IDE5LjA2IDQuMTgwMTggMjAgNS4wMDAxOCAyMEgxOS4wMDAyQzE5LjgyMDIgMjAgMjAuMjkwMiAxOS4wNiAxOS44MDAyIDE4LjRaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Science = createIcon('Science', [
  [
    'path',
    {
      d: 'M19.8002 18.4L14.0002 10.67V6.5L15.3502 4.81C15.6102 4.48 15.3802 4 14.9602 4H9.04018C8.62018 4 8.39017 4.48 8.65018 4.81L10.0002 6.5V10.67L4.20018 18.4C3.71018 19.06 4.18018 20 5.00018 20H19.0002C19.8202 20 20.2902 19.06 19.8002 18.4Z',
      key: 'jf976d',
    },
  ],
]);

export default Science;
